import {
  isValidPhoneNumber,
  isValidEmail,
  normalizePhoneNumberRedesign,
  isValidNANPPhoneNumber,
  isNotSamePhoneNumber,
} from '../../common/validation';
import { eventDispatcher } from '../../common/Tagging/index';
import { getProductRefData } from '../../../utils/plansReference';

export const phoneNumberFormat = (number) => (number ? number?.replace(/\./g, '') : null);
export const removeNonAlphanumeric = (val) => val?.replace(/([^\w ]|_)/g, '')?.trim() || ' ';

export const isInvalidPhoneNumber = (val) => {
  const parsedNumber = phoneNumberFormat(val);
  return !isValidPhoneNumber(parsedNumber) || parsedNumber?.length !== 10 || parsedNumber === '0000000000' || parsedNumber === '9999999999';
};
export const isInvalidNANPPhoneNumber = (val) => {
  const normalizedNumber = normalizePhoneNumberRedesign(val);
  return isValidNANPPhoneNumber(normalizedNumber);
};

export const validateEmailonChange = (val) => {
  if (val === '' || !isValidEmail(val)) {
    return 'Please enter a valid email address';
  }
  return '';
};

export const parseEmailBannerText = (text, email) => {
  const response = text?.split('<br>');
  return {
    title: response?.[0],
    subtitle: response?.[1]?.replace('<email address>', email),
    confirmText: response?.[2],
  };
};

export const isMobileNumberInvalid = (val) => !val || isInvalidPhoneNumber(val) || isInvalidNANPPhoneNumber(val) || isNotSamePhoneNumber(val);

export const isEmailInvalid = (emailId) => emailId === '' || emailId === null || !isValidEmail(emailId);

export const isPhoneNumberInvalid = (phoneNo) => phoneNo === '' || phoneNo === null || !isValidPhoneNumber(phoneNumberFormat(phoneNo?.trim()));

export const isEmailValid = (isEmailSuccess) =>
  isEmailSuccess?.valid === 'Valid' || isEmailSuccess?.valid === 'White_listed' || isEmailSuccess?.valid === 'true';

export const setEmailLinkStyles = (emailLinkObj, styles) => {
  const domElement = emailLinkObj;
  Object.keys(styles).forEach((key) => {
    domElement.style[key] = styles[key];
  });
};

export const setEmailLinkAttributes = (emailLinkObj, attributes) => {
  const domElement = emailLinkObj;
  Object.keys(attributes).forEach((key) => {
    domElement.setAttribute(key, attributes[key]);
  });
};

export const dispatchEmailEvent = (text) => {
  const obj = {
    name: '',
    svars: {
      evar13: text,
    },
  };
  eventDispatcher('sendData', obj);
};

export const getSelectedDayTimeSlots = (state, selectedDate) => {
  const availableSlots = state?.appointmentStateValue?.appointmentScheduleResponse?.output?.apptAvailableDays || [];
  return availableSlots?.filter((slot) => slot.date === selectedDate)?.[0]?.apptAvailableTime;
};

const getDateValue = (date) => {
  const today = new Date(date);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return { year, month, day };
};

export const getDateWithSlash = (date) => {
  const { year, month, day } = splitDateValue(date);
  return `${month}/${day}/${year}`;
};

export const getDateWithoutSlash = (date) => {
  const { year, month, day } = getDateValue(date);
  return `${year}${month}${day}`;
};

export const getFormattedDate = (date) => {
  const { year, month, day } = getDateValue(date);
  return `${month}/${day}/${year}`;
};

const splitDateValue = (dateValue) => {
  const year = dateValue?.substring(0, 4);
  const month = dateValue?.substring(4, 6);
  const day = dateValue?.substring(6, 8);
  return { year, month, day };
};

export const getSelectedDateFormat = (date) => {
  const { year, month, day } = getDateValue(date);
  return `${month}/${day}/${year}`;
};

export const getMaxDate = () => {
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);
  return maxDate;
};
export const getVideoUrl = (eligible5GHomeBundle, plansReferenceData, dueTodayList) => {
  if (!eligible5GHomeBundle && !dueTodayList) {
    return null;
  }
  const selfObj = getSelfObjId(eligible5GHomeBundle, dueTodayList);
  return selfObj ? getProductRefData(selfObj, '', plansReferenceData) : null;
};

const getSelfObjId = (eligible5GHomeBundle, dueTodayList) => {
  const selfBundleId = eligible5GHomeBundle?.find((item) => item?.bundleName?.includes('Self'))?.id;
  const deviceSorId = dueTodayList?.find((item) => item?.itemType === 'DEVICE')?.sorId;
  return selfBundleId || deviceSorId;
};
